import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import {
  GetCheckListReq,
  GetCheckListByIdReq,
  DeleteCheckListReq,
  CreateCheckListReq,
  UpdateCheckListReq,
  CheckListItem,
  CheckListDetail,
} from './types'
import { GetApiResponse, List } from 'features/types/common'
import { ProjectCheckListResp } from 'features/types/checklist'

export const getCheckListAction = createAsyncAction(
  'checklist/constructPlan/GET_CHECK_LIST_REQ',
  'checklist/constructPlan/GET_CHECK_LIST_RESP',
  'checklist/constructPlan/GET_CHECK_LIST_FAIL'
)<GetCheckListReq, GetApiResponse<List<CheckListItem>>, Error>()

export const getCheckListByIdAction = createAsyncAction(
  'checklist/constructPlan/GET_CHECK_ID_REQ',
  'checklist/constructPlan/GET_CHECK_ID_RESP',
  'checklist/constructPlan/GET_CHECK_ID_FAIL'
)<GetCheckListByIdReq, GetApiResponse<CheckListDetail>, any>()

export const createCheckListAction = createAsyncAction(
  'checklist/constructPlan/CREATE_CHECK_ID_REQ',
  'checklist/constructPlan/CREATE_CHECK_ID_RESP',
  'checklist/constructPlan/CREATE_CHECK_ID_FAIL'
)<CreateCheckListReq, any, any>()

export const updateCheckListAction = createAsyncAction(
  'checklist/constructPlan/UPDATE_CHECK_ID_REQ',
  'checklist/constructPlan/UPDATE_CHECK_ID_RESP',
  'checklist/constructPlan/UPDATE_CHECK_ID_FAIL'
)<UpdateCheckListReq, any, any>()

export const deleteCheckListAction = createAsyncAction(
  'checklist/constructPlan/DELETE_CHECK_ID_REQ',
  'checklist/constructPlan/DELETE_CHECK_ID_RESP',
  'checklist/constructPlan/DELETE_CHECK_ID_FAIL'
)<DeleteCheckListReq, any, any>()

export const clearCheckListDetail = createStandardAction(
  'checklist/constructPlan/CLEAR_CHECK_LIST_DETAIL'
)<void>()

export const updateCheckListDetail = createStandardAction(
  'checklist/constructPlan/UPDATE_CHECKLIST_DETAIL'
)<CheckListDetail>()

export const getProjectAction = createAsyncAction(
  'checklist/constructPlan/GET_PROJECT_REQ',
  'checklist/constructPlan/GET_PROJECT_RESP',
  'checklist/constructPlan/GET_PROJECT_FAIL'
)<any, ProjectCheckListResp, any>()
